const Builder = require('./BuilderBase');

module.exports = class Swagger extends Builder {
    constructor(title, properties) {
        super('documentation_Swagger', title, properties);
    }
};
